"use client";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createSession } from "../../api/session.api";
import { generateTimeSlots } from "../../utils/time.util";


const CreateSession = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const timeSlots = generateTimeSlots(30);


  const { domeData: dome } = location.state || {};
  console.log("🚀 ~ CreateSession ~ dome:", dome);

  const [sessionData, setSessionData] = useState({
    name: "",
    startTime: "",
    duration: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Generic input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSessionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle time selection
  const handleTimeChange = (e) => {
    setSessionData((prev) => ({ ...prev, startTime: e.target.value }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = {
        domeRef: dome._id,
        startTime: sessionData.startTime,
      };

      const response = await createSession(data);
      console.log("✅ Session created:", response);
      navigate(-1); // Go back to sessions list page
    } catch (err) {
      console.error(err);
      setError(err?.message || "Failed to create session");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4 px-3 px-md-0">
      <div className="d-flex align-items-center mb-4">
        <button
          onClick={() => navigate(-1)}
          className="btn btn-outline-secondary me-3"
        >
          <i className="fas fa-arrow-left me-2"></i>Back
        </button>
        <h2 className="fs-24 fs-md-32 mb-0">
          Create Timeslot for:{" "}
          <span className="text-primary">{dome?.domeName}</span>
        </h2>
      </div>

      <form onSubmit={handleSubmit} className="mt-3">
        {/* Start Time */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Start Time</label>
            <select
              name="startTime"
              onChange={handleTimeChange}
              value={sessionData.startTime}
              className="form-select"
              required
            >
              <option value="">Select Start Time</option>
              {timeSlots.map((slot) => (
                <option key={slot} value={slot}>
                  {slot}
                </option>
              ))}
            </select>
          </div>

        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Creating..." : "Create Timeslot"}
        </button>
      </form>
    </div>
  );
};

export default CreateSession;
